import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {navigation} from "../containers/App";

function Header(props) {
    const [showMenu, setShowMenu] = useState(false)

    useEffect(() => {
        const handleClick = (e) => {
            const href = e.target.closest('a')?.getAttribute('href');
            if (href && href.startsWith('/#')) {
                setShowMenu(false)
                const id = href.substring(2);
                const element = document.getElementById(id);
                if (element) {
                    if (id === "home") {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    } else {
                        const yOffset = -100;
                        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
                        window.scrollTo({ top: y, behavior: 'smooth' });
                    }
                    e.preventDefault();
                }
            }
        };

        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
    }, []);

    return <header>
        <div className={"icon"}/>
        <div className={"header-container"}>
            <div className={"navigation-container"}>
                {Object.entries(navigation).map(([key, value]) => <Link className={"title"} key={key} to={{pathname: "/", hash: "#" + key}}>{value}</Link>)}
            </div>
        </div>
        <div className={"header-container-mobile-version"}>

            <div className={"hamburger-menu"} onClick={() => setShowMenu(true)}>
                <div className={"line first"}/>
                <div className={"line second"}/>
                <div className={"line third"}/>
            </div>
        </div>
        <div className={"mobile-menu" + (showMenu ? " show" : "")}>
            <div className={"x-container"} onClick={() => setShowMenu(false)}>X</div>
            <div className={"links"}>
                {Object.entries(navigation).map(([key, value]) => <Link key={key} to={{pathname: "/", hash: "#" + key}}>{value}</Link>)}
            </div>
        </div>
    </header>
}

export default Header;